import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/pro-duotone-svg-icons";
import { Button } from 'react-bootstrap';
import React, { useState, useCallback } from 'react';
import Actions from "./actions";

function ButtonActions(props) {
    
    const [showActions, setShowActions] = useState(false);

    const toggleSettings = () => setShowActions(prev => !prev);

    return (
        <div className="float-end m-1 position-relative">
            <Button variant="light-primary" size="sm" onClick={toggleSettings}>
                <FontAwesomeIcon icon={faBars} />
            </Button>
            {showActions && (
                <div style={{ left: 50 }} className="position-relative">
                    <Actions {...props} toggleSettings={toggleSettings} showActions={showActions} />
                </div>
            )}
        </div>
    );
}

export default ButtonActions;